import {ResourceParams} from "../resources";

export type CommonResourceType =
  'record-calendars-promotion-specialist';

export const commonResources: {
  [key in CommonResourceType]: ResourceParams
} = {
  'record-calendars-promotion-specialist': {
    key: 'record-calendars-promotion-specialist',
    name: 'Рекламные Кампании',
    path: 'record-calendars-promotion-specialist'
  }
};
